import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import withClickOutsideOnOverlay from '../../hoc/withClickOutsideOnOverlay';
import ValidationForm from './ValidationForm';
import PopupWrapper from '../components/Popup/PopupWrapper';
import PopupHeader from '../components/Popup/PopupHeader';
import PopupBody from '../components/Popup/PopupBody';
import PopupButtons from '../components/Popup/PopupButtons';
import { okButtonClass, cancelButtonClass } from '../../const/popupButtonClasses';
import { popupHeaderIcons } from '../../services/mini/popupHeaderIcons';
function BasicFormWithValidation({ title, titleIcon, titleIconImg, type, hasCloseIcon, inputs, className, okButton, cancelButton, enableActionBtnByDefault }) {

    const buttons = React.useMemo(() => [
        {
            key: 'cancel',
            label: cancelButton.label,
            action: cancelButton.action,
            className: cancelButtonClass
        },
        {
            key: 'ok',
            label: okButton.label,
            action: okButton.action,
            className: okButtonClass
        }
    ], [cancelButton.action, cancelButton.label, okButton.action, okButton.label]);

    const cancelCb = useCallback(() => {
        if (cancelButton) {
            cancelButton.action();
        }
    }, [cancelButton]);

    return (
        <PopupWrapper className={className}>
            <PopupHeader
                title={title}
                titleIconImg={titleIconImg}
                titleIcon={titleIcon || (type ? popupHeaderIcons[type] : null)}
                onCancel={cancelCb} />
            <PopupBody>
                <ValidationForm
                    buttonsWrapper={PopupButtons}
                    enableActionBtnByDefault={enableActionBtnByDefault}
                    inputs={inputs}
                    buttons={buttons} />
            </PopupBody>
        </PopupWrapper>
    );
}

BasicFormWithValidation.propTypes = {
    inputs: PropTypes.array.isRequired,
    okButton: PropTypes.object.isRequired,
    cancelButton: PropTypes.object.isRequired,
    btnsClassName: PropTypes.string,
    formClassName: PropTypes.string,
    enableActionBtnByDefault: PropTypes.bool,
    enableActionBtnAlways: PropTypes.bool,
};

export default withClickOutsideOnOverlay(BasicFormWithValidation);